/**
 * Forg3D — Script principal du prototype HTML
 * Navigation mobile, galerie produit, lazy load, accessibilité motion.
 */
(function () {
  'use strict';

  /* Menu mobile forge : panneau latéral + overlay */
  const navToggle = document.querySelector('.nav-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileNavCloseButtons = mobileNav?.querySelectorAll('[data-mobile-nav-close]');

  function setMobileNavOpen(isOpen) {
    if (!mobileNav || !navToggle) return;

    mobileNav.classList.toggle('is-open', isOpen);
    navToggle.classList.toggle('is-active', isOpen);
    navToggle.setAttribute('aria-expanded', String(isOpen));
    navToggle.setAttribute('aria-label', isOpen ? 'Fermer le menu' : 'Ouvrir le menu');
    mobileNav.setAttribute('aria-hidden', String(!isOpen));
    document.body.classList.toggle('mobile-nav-open', isOpen);

    if (isOpen) {
      mobileNav.removeAttribute('inert');
    } else {
      mobileNav.setAttribute('inert', '');
    }
  }

  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', () => {
      setMobileNavOpen(!mobileNav.classList.contains('is-open'));
    });

    mobileNavCloseButtons?.forEach((btn) => {
      btn.addEventListener('click', () => setMobileNavOpen(false));
    });

    mobileNav.querySelectorAll('.mobile-nav__link, .mobile-nav__cta, .faction-tile').forEach((link) => {
      link.addEventListener('click', () => setMobileNavOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        setMobileNavOpen(false);
      }
    });
  }

  /* Mega menu factions — desktop et mobile */
  function setMegaOpen(wrap, isOpen) {
    const trigger = wrap.querySelector('.site-nav__mega-trigger, .mobile-nav__mega-toggle');
    const panel = wrap.querySelector('.faction-mega');
    if (!trigger || !panel) return;

    wrap.classList.toggle('is-open', isOpen);
    trigger.setAttribute('aria-expanded', String(isOpen));
    panel.hidden = !isOpen;
  }

  document.querySelectorAll('[data-faction-mega]').forEach((wrap) => {
    const trigger = wrap.querySelector('.site-nav__mega-trigger');
    const panel = wrap.querySelector('.faction-mega');

    if (!trigger || !panel) return;

    let closeTimer = null;
    const closeDelayMs = 320;

    function isPointerInMega(node) {
      if (!node || !(node instanceof Node)) return false;
      return wrap.contains(node);
    }

    function cancelClose() {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function scheduleClose() {
      /* Ouvert au clic : ne pas fermer tant qu’un clic extérieur n’a pas lieu */
      if (wrap.hasAttribute('data-mega-click-locked')) return;

      cancelClose();
      closeTimer = window.setTimeout(() => {
        setMegaOpen(wrap, false);
        closeTimer = null;
      }, closeDelayMs);
    }

    function openMega() {
      cancelClose();
      document.querySelectorAll('[data-faction-mega].is-open').forEach((other) => {
        if (other !== wrap) {
          other.removeAttribute('data-mega-click-locked');
          setMegaOpen(other, false);
        }
      });
      setMegaOpen(wrap, true);
    }

    function onPointerLeave(event) {
      if (isPointerInMega(event.relatedTarget)) return;
      scheduleClose();
    }

    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      if (wrap.classList.contains('is-open')) {
        wrap.removeAttribute('data-mega-click-locked');
        setMegaOpen(wrap, false);
      } else {
        wrap.setAttribute('data-mega-click-locked', 'true');
        openMega();
      }
    });

    trigger.addEventListener('mouseenter', openMega);
    trigger.addEventListener('mouseleave', onPointerLeave);
    panel.addEventListener('mouseenter', openMega);
    panel.addEventListener('mouseleave', onPointerLeave);

    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        cancelClose();
        wrap.removeAttribute('data-mega-click-locked');
        setMegaOpen(wrap, false);
        trigger.focus();
      }
    });
  });

  document.querySelectorAll('[data-mobile-faction-mega]').forEach((wrap) => {
    const trigger = wrap.querySelector('.mobile-nav__mega-toggle');
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
      setMegaOpen(wrap, willOpen);
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-faction-mega]')) return;
    document.querySelectorAll('[data-faction-mega].is-open').forEach((wrap) => {
      wrap.removeAttribute('data-mega-click-locked');
      setMegaOpen(wrap, false);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-faction-mega].is-open').forEach((wrap) => {
      wrap.removeAttribute('data-mega-click-locked');
      setMegaOpen(wrap, false);
    });
  });

  /* Galerie fiche produit : variantes + préchargement + lightbox au clic */
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImg = gallery.querySelector('.product-gallery__main img');
    const zoomBtn = gallery.querySelector('[data-product-gallery-zoom]');
    const thumbs = Array.from(gallery.querySelectorAll('.product-gallery__thumb'));
    const lightboxTriggers = Array.from(
      gallery.querySelectorAll('.product-gallery__lightbox-sources [data-forge-lightbox-trigger]')
    );
    const form = gallery.closest('.product-layout')?.querySelector('.product-form');
    const variantsScript = form?.querySelector('[id^="product-variants-"]');
    const optionSelects = form?.querySelectorAll('[data-product-option]');

    if (!mainImg) return;

    const preloadedUrls = new Set();

    function preloadImage(url) {
      if (!url || preloadedUrls.has(url)) return;
      preloadedUrls.add(url);
      const img = new Image();
      img.decoding = 'async';
      img.src = url;
    }

    function preloadLightboxSources() {
      lightboxTriggers.forEach((trigger) => {
        if (trigger.hidden) return;
        preloadImage(trigger.dataset.forgeLightboxSrc);
      });
    }

    function preloadLightboxForThumb(thumb) {
      const trigger = lightboxTriggers.find(
        (item) => item.dataset.mediaId === thumb.dataset.mediaId
      );
      if (trigger?.dataset.forgeLightboxSrc) {
        preloadImage(trigger.dataset.forgeLightboxSrc);
      }
    }

    preloadLightboxSources();

    function syncLightboxSourcesVisibility() {
      if (!thumbs.length) return;

      thumbs.forEach((thumb) => {
        const trigger = lightboxTriggers.find(
          (item) => item.dataset.mediaId === thumb.dataset.mediaId
        );
        if (trigger) trigger.hidden = thumb.hidden;
      });
    }

    function getActiveMediaId() {
      const activeThumb = thumbs.find((thumb) => thumb.classList.contains('is-active') && !thumb.hidden);
      if (activeThumb?.dataset.mediaId) return activeThumb.dataset.mediaId;

      const visibleTrigger = lightboxTriggers.find((trigger) => !trigger.hidden);
      return visibleTrigger?.dataset.mediaId || null;
    }

    function openActiveLightbox() {
      syncLightboxSourcesVisibility();
      const activeId = getActiveMediaId();
      const visibleTriggers = lightboxTriggers.filter((trigger) => !trigger.hidden);
      const trigger =
        visibleTriggers.find((item) => item.dataset.mediaId === activeId) || visibleTriggers[0];
      trigger?.click();
    }

    zoomBtn?.addEventListener('click', openActiveLightbox);

    if (thumbs.length === 0) return;

    function preloadThumbSources(thumbList) {
      thumbList.forEach((thumb) => {
        if (thumb.hidden) return;
        preloadImage(thumb.dataset.src);
        preloadLightboxForThumb(thumb);
      });
    }

    function mediaMatchesVariant(thumb, variantId) {
      if (thumb.dataset.attachedToVariant !== 'true') return true;
      const ids = thumb.dataset.variantIds?.split(',').filter(Boolean) || [];
      return ids.includes(String(variantId));
    }

    function activateThumb(thumb) {
      if (!thumb || thumb.hidden) return;

      thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));

      const nextSrc = thumb.dataset.src;
      if (!nextSrc) return;

      preloadImage(nextSrc);
      preloadLightboxForThumb(thumb);
      mainImg.src = nextSrc;

      if (thumb.dataset.srcset) {
        mainImg.srcset = thumb.dataset.srcset;
      } else {
        mainImg.removeAttribute('srcset');
      }

      const thumbImg = thumb.querySelector('img');
      if (thumbImg?.alt) {
        mainImg.alt = thumbImg.alt;
      }

      syncLightboxSourcesVisibility();
    }

    function updateGalleryForVariant(variant) {
      if (!variant) return;

      thumbs.forEach((thumb) => {
        const visible = mediaMatchesVariant(thumb, variant.id);
        thumb.hidden = !visible;
        thumb.classList.toggle('is-hidden', !visible);
      });

      const visibleThumbs = thumbs.filter((thumb) => !thumb.hidden);
      const featuredId = variant.featured_media?.id;
      const featuredThumb = featuredId
        ? visibleThumbs.find((thumb) => thumb.dataset.mediaId === String(featuredId))
        : null;

      activateThumb(featuredThumb || visibleThumbs[0]);
      preloadThumbSources(visibleThumbs);
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => activateThumb(thumb));
      thumb.addEventListener('mouseenter', () => {
        preloadImage(thumb.dataset.src);
        preloadLightboxForThumb(thumb);
      });
      thumb.addEventListener('focus', () => {
        preloadImage(thumb.dataset.src);
        preloadLightboxForThumb(thumb);
      });
    });

    preloadThumbSources(thumbs.filter((thumb) => !thumb.hidden));

    if (!form || !variantsScript || !optionSelects?.length) return;

    let variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch {
      return;
    }

    const originalUpdate = () => {
      const selected = Array.from(optionSelects).map((select) => select.value);
      return variants.find((variant) =>
        variant.options.every((option, index) => option === selected[index])
      );
    };

    optionSelects.forEach((select) => {
      select.addEventListener('change', () => {
        const variant = originalUpdate();
        if (variant) updateGalleryForVariant(variant);
      });
    });
  });

  /* Fiche produit : synchronisation variante ↔ champ id (évite mauvais ajout panier) */
  document.querySelectorAll('.product-form').forEach((form) => {
    const variantInput = form.querySelector('input[name="id"]');
    const optionSelects = form.querySelectorAll('[data-product-option]');
    const variantsScript = form.querySelector('[id^="product-variants-"]');

    if (!variantInput || !variantsScript || optionSelects.length === 0) return;

    let variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch {
      return;
    }

    const addButton = form.querySelector('[name="add"]');
    const sectionId = variantsScript.id.replace('product-variants-', '');
    const priceEl = document.getElementById('product-price-' + sectionId);

    function renderPrice(variant) {
      if (!priceEl) return;

      const priceTemplate = form.querySelector('template[data-variant-price="' + variant.id + '"]');
      if (!priceTemplate) return;

      const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceEl.classList.toggle('product-info__price--sale', Boolean(hasCompare));
      // Garder le HTML Shopify et laisser les apps convertir les nouveaux prix.
      priceEl.replaceChildren(priceTemplate.content.cloneNode(true));
    }

    function setAddButtonState(variant) {
      if (!addButton) return;

      const hasVariant = Boolean(variant);
      const isAvailable = hasVariant && variant.available;
      const isDisabled = !hasVariant || !isAvailable;

      addButton.disabled = isDisabled;
      addButton.classList.toggle('btn-forge--primary', !isDisabled);
      addButton.classList.toggle('btn-forge--glow', !isDisabled);
      addButton.classList.toggle('btn-forge--ash', isDisabled);

      const addText = addButton.dataset.addText || 'Ajouter au panier';
      const soldText = addButton.dataset.soldOutText || 'Rupture de stock';
      addButton.textContent = hasVariant && !isAvailable ? soldText : addText;
    }

    function updateVariant(options) {
      const syncPrice = options?.syncPrice === true;
      const selected = Array.from(optionSelects).map((select) => select.value);
      const variant = variants.find((v) =>
        v.options.every((option, index) => option === selected[index])
      );

      if (!variant) {
        variantInput.value = '';
        variantInput.disabled = true;
        setAddButtonState(null);
        if (syncPrice && priceEl) {
          priceEl.textContent = window.themeStrings?.unavailableVariant || 'Combinaison indisponible';
        }
        return;
      }

      variantInput.disabled = false;
      variantInput.value = variant.id;

      setAddButtonState(variant);

      if (syncPrice) {
        renderPrice(variant);
      }
    }

    optionSelects.forEach((select) => {
      select.addEventListener('change', () => updateVariant({ syncPrice: true }));
    });
  });

  /* Chargement différé des images avec data-src (IntersectionObserver) */
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
            }
            observer.unobserve(img);
          }
        });
      },
      { rootMargin: '100px' }
    );
    lazyImages.forEach((img) => observer.observe(img));
  }

  /* Retour en haut de page (footer) */
  document.querySelectorAll('.back-to-top').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    });
  });

  /* Chaîne de lave — maillons = sections accueil dans l'ordre de la page (data-lava-nav-label) */
  (function initLavaChainNav() {
    const nav = document.querySelector('[data-lava-chain-nav]');
    if (!nav) return;

    const list = nav.querySelector('.lava-chain-nav__list');
    const itemTemplate = nav.querySelector('[data-lava-chain-item-template]');
    const fill = nav.querySelector('.lava-chain-nav__fill');
    const track = nav.querySelector('.lava-chain-nav__track');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!list || !itemTemplate) return;

    let sections = [];

    function getHeaderOffset() {
      const headerInner = document.querySelector('.site-header__inner');
      const value = headerInner
        ? getComputedStyle(headerInner).getPropertyValue('--site-header-height').trim()
        : '';
      const parsed = Number.parseFloat(value);
      return Number.isFinite(parsed) ? parsed + 12 : 144;
    }

    function getSectionDocumentTop(el) {
      return el.getBoundingClientRect().top + window.scrollY;
    }

    function syncLavaTrackEnds() {
      if (!track) return;

      const items = nav.querySelectorAll('.lava-chain-nav__item');
      if (items.length === 0) return;

      const firstNode = items[0].querySelector('.lava-chain-nav__node');
      const lastNode = items[items.length - 1].querySelector('.lava-chain-nav__node');
      if (!firstNode || !lastNode) return;

      const firstSvg = firstNode.querySelector('.lava-chain-nav__svg');
      const lastSvg = lastNode.querySelector('.lava-chain-nav__svg');
      const navRect = nav.getBoundingClientRect();
      const firstMeasure = (firstSvg || firstNode).getBoundingClientRect();
      const lastMeasure = (lastSvg || lastNode).getBoundingClientRect();
      const pillTopRatio = 5 / 52;
      const pillBottomRatio = 47 / 52;
      const trackW = track.offsetWidth || 10;
      const topTrim = trackW * 0.5 + 2;

      track.style.top = `${Math.max(0, firstMeasure.top - navRect.top + firstMeasure.height * pillTopRatio + topTrim)}px`;
      track.style.bottom = `${Math.max(0, navRect.bottom - (lastMeasure.top + lastMeasure.height * pillBottomRatio))}px`;
    }

    function setActive(activeEntry) {
      if (!activeEntry) return;

      sections.forEach(({ link }) => {
        link.classList.toggle('is-active', link === activeEntry.link);
      });

      if (fill && sections.length > 1) {
        const index = sections.indexOf(activeEntry);
        const ratio = index / (sections.length - 1);
        fill.style.setProperty('--lava-fill', `${Math.round(ratio * 100)}%`);
      }
    }

    function resolveActiveSection() {
      if (!sections.length) return;

      const headerOffset = getHeaderOffset();
      const viewportBottom = window.scrollY + window.innerHeight;
      const docBottom = document.documentElement.scrollHeight;

      if (viewportBottom >= docBottom - 2) {
        setActive(sections[sections.length - 1]);
        return;
      }

      const scrollProbe = window.scrollY + headerOffset + window.innerHeight * 0.3;
      let current = sections[0];

      for (let index = sections.length - 1; index >= 0; index -= 1) {
        if (getSectionDocumentTop(sections[index].el) <= scrollProbe) {
          current = sections[index];
          break;
        }
      }

      setActive(current);
    }

    function buildChainFromPageSections() {
      list.textContent = '';

      const pageSections = Array.from(
        document.querySelectorAll('main [id^="home-"][data-lava-nav-label]')
      );

      sections = pageSections.map((el, index) => {
        const label = el.dataset.lavaNavLabel;
        const item = itemTemplate.content.firstElementChild.cloneNode(true);
        const link = item.querySelector('[data-lava-target]');
        const labelEl = item.querySelector('.lava-chain-nav__label');

        link.dataset.lavaTarget = el.id;
        link.setAttribute('aria-label', label);
        link.classList.toggle('is-active', index === 0);
        labelEl.textContent = label;

        link.addEventListener('click', () => {
          const top = getSectionDocumentTop(el) - getHeaderOffset();
          window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion ? 'auto' : 'smooth' });
          setActive(sections.find((entry) => entry.el === el));
        });

        list.appendChild(item);
        return { link, el };
      });
    }

    function refreshChainLayout() {
      buildChainFromPageSections();
      resolveActiveSection();
      syncLavaTrackEnds();
    }

    let scrollTick = false;
    window.addEventListener(
      'scroll',
      () => {
        if (scrollTick) return;
        scrollTick = true;
        window.requestAnimationFrame(() => {
          resolveActiveSection();
          scrollTick = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('load', refreshChainLayout, { passive: true });
    window.addEventListener('resize', refreshChainLayout, { passive: true });

    refreshChainLayout();
    requestAnimationFrame(() => {
      syncLavaTrackEnds();
      requestAnimationFrame(syncLavaTrackEnds);
    });
  })();

  /* Supprimer les braises si l'utilisateur préfère moins d'animations */
  const embersContainer = document.querySelector('.embers-container');
  if (embersContainer && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    embersContainer.remove();
  }

  /* Contenu riche : encadrer les paragraphes « Important / Attention » (legacy admin) */
  const noticePattern = /^(important|attention|note|a\s*noter)\s*:/i;

  document.querySelectorAll('[data-forge-rte]').forEach((root) => {
    const paragraphs = Array.from(root.querySelectorAll(':scope > p')).filter(
      (paragraph) => !paragraph.closest('.forge-notice')
    );
    const firstNoticeIndex = paragraphs.findIndex((paragraph) =>
      noticePattern.test(paragraph.textContent.trim())
    );

    if (firstNoticeIndex >= 0) {
      paragraphs.slice(firstNoticeIndex).forEach((paragraph) => {
        paragraph.classList.add('forge-notice', 'forge-notice--warning');
        paragraph.setAttribute('role', 'note');
      });
    } else {
      paragraphs.forEach((paragraph) => {
        if (noticePattern.test(paragraph.textContent.trim())) {
          paragraph.classList.add('forge-notice', 'forge-notice--warning');
          paragraph.setAttribute('role', 'note');
        }
      });
    }

    root.querySelectorAll('[class*="forge-notice--"]').forEach((node) => {
      if (!node.classList.contains('forge-notice')) {
        node.classList.add('forge-notice');
      }
    });
  });

  /* Panier : animation forge au clic sur Commander */
  const cartForm = document.getElementById('cart-form');
  const checkoutBtn = document.querySelector('[data-forge-checkout]');
  const forgeStatus = document.getElementById('forge-checkout-status');
  const FORGE_DURATION_MS = 2500;
  const FORGE_STRIKE_MS = 480;

  /* Son de marteau — lecture simple du MP3 themeAssets.hammerSound */
  let forgeHammerAudio = null;

  function playForgeHammerSound() {
    const src = window.themeAssets?.hammerSound;
    if (!src) return;

    if (!forgeHammerAudio) {
      forgeHammerAudio = new Audio(src);
      forgeHammerAudio.preload = 'auto';
    }

    forgeHammerAudio.currentTime = 0;
    forgeHammerAudio.volume = 1;
    void forgeHammerAudio.play().catch(() => {});
  }

  function spawnForgeSparks(button) {
    const sparkCount = 7;

    for (let i = 0; i < sparkCount; i += 1) {
      const spark = document.createElement('span');
      spark.className = 'forge-spark';
      spark.setAttribute('aria-hidden', 'true');
      spark.style.left = `${42 + Math.random() * 16}%`;
      spark.style.top = `${38 + Math.random() * 24}%`;
      spark.style.setProperty('--forge-spark-x', `${(Math.random() - 0.5) * 56}px`);
      spark.style.setProperty('--forge-spark-y', `${-18 - Math.random() * 42}px`);
      button.appendChild(spark);
      requestAnimationFrame(() => spark.classList.add('is-active'));
      window.setTimeout(() => spark.remove(), 520);
    }
  }

  function triggerForgeStrike(button, hammer) {
    button.classList.remove('is-strike');
    hammer?.classList.remove('is-strike');
    void button.offsetWidth;
    button.classList.add('is-strike');
    hammer?.classList.add('is-strike');
    spawnForgeSparks(button);
  }

  if (cartForm && checkoutBtn) {
    checkoutBtn.addEventListener('click', (event) => {
      if (checkoutBtn.dataset.forging === 'true') {
        event.preventDefault();
        return;
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      event.preventDefault();

      const cartSummary = checkoutBtn.closest('.cart-summary');
      const label = checkoutBtn.querySelector('.cart-checkout__label');
      const forgeLabels = ['Forge en cours…', 'Martelage…', 'Forgée !'];
      let labelStep = 0;

      checkoutBtn.dataset.forging = 'true';
      checkoutBtn.classList.add('is-forging');
      cartSummary?.classList.add('is-forging');
      document.body.classList.add('is-forging-order');

      if (label) {
        label.textContent = forgeLabels[0];
      }
      if (forgeStatus) {
        forgeStatus.textContent = forgeLabels[0];
      }

      playForgeHammerSound();

      const hammer = document.createElement('div');
      hammer.className = 'forge-order-cursor';
      hammer.setAttribute('aria-hidden', 'true');
      const hammerIcon = document.createElement('i');
      hammerIcon.className = 'fa-solid fa-hammer forge-order-cursor__icon';
      hammer.appendChild(hammerIcon);
      document.body.appendChild(hammer);

      /* Position initiale = clic (hotspot curseur) */
      const startX = event.clientX;
      const startY = event.clientY;

      const moveForgeCursor = (x, y) => {
        hammer.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      };

      const onMove = (moveEvent) => {
        const point = moveEvent.touches?.[0] ?? moveEvent;
        moveForgeCursor(point.clientX, point.clientY);
      };

      document.addEventListener('mousemove', onMove, { passive: true });
      document.addEventListener('touchmove', onMove, { passive: true });

      moveForgeCursor(startX, startY);
      triggerForgeStrike(checkoutBtn, hammer);

      const strikeTimer = window.setInterval(() => {
        triggerForgeStrike(checkoutBtn, hammer);
      }, FORGE_STRIKE_MS);

      const labelTimer = window.setInterval(() => {
        labelStep += 1;
        if (labelStep < forgeLabels.length && label) {
          label.textContent = forgeLabels[labelStep];
          if (forgeStatus) {
            forgeStatus.textContent = forgeLabels[labelStep];
          }
        }
      }, 850);

      window.setTimeout(() => {
        window.clearInterval(strikeTimer);
        window.clearInterval(labelTimer);
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('touchmove', onMove);
        hammer.remove();
        document.body.classList.remove('is-forging-order');
        cartSummary?.classList.remove('is-forging');
        checkoutBtn.classList.remove('is-forging', 'is-strike');
        delete checkoutBtn.dataset.forging;

        if (label) {
          label.textContent = 'Forgée !';
        }
        if (forgeStatus) {
          forgeStatus.textContent = 'Commande forgée, passage au paiement.';
        }

        /* Navigation directe — requestSubmit relancerait le handler click et bloquerait */
        const checkoutUrl = window.themeRoutes?.checkout || '/checkout';
        window.location.assign(checkoutUrl);
      }, FORGE_DURATION_MS);
    });
  }

  /* Collection — listes déroulantes forge (sculpteur + tri) */
  function setForgeSelectOpen(root, isOpen) {
    const trigger = root.querySelector('.forge-select__trigger');
    const panel = root.querySelector('.forge-select__panel');
    if (!trigger || !panel) return;

    root.classList.toggle('is-open', isOpen);
    trigger.setAttribute('aria-expanded', String(isOpen));
    panel.hidden = !isOpen;
  }

  function closeAllForgeSelects(except) {
    document.querySelectorAll('[data-forge-select].is-open').forEach((root) => {
      if (root !== except) {
        setForgeSelectOpen(root, false);
      }
    });
  }

  document.querySelectorAll('[data-forge-select]').forEach((root) => {
    const trigger = root.querySelector('.forge-select__trigger');
    const options = root.querySelectorAll('.forge-select__option');
    const behavior = root.dataset.forgeSelectBehavior || 'navigate';

    if (!trigger) return;

    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      const willOpen = !root.classList.contains('is-open');
      closeAllForgeSelects(willOpen ? root : null);
      setForgeSelectOpen(root, willOpen);
    });

    options.forEach((option) => {
      option.addEventListener('click', () => {
        const value = option.dataset.value;
        if (!value) return;

        if (behavior === 'sort') {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', value);
          window.location.assign(url.toString());
          return;
        }

        window.location.assign(value);
      });
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-forge-select]')) {
      closeAllForgeSelects(null);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllForgeSelects(null);
    }
  });

  /* Lightbox forge — galeries [data-forge-lightbox] */
  const forgeLightbox = document.getElementById('forge-lightbox');

  if (forgeLightbox) {
    const lightboxImage = forgeLightbox.querySelector('.forge-lightbox__image');
    const lightboxCaption = forgeLightbox.querySelector('.forge-lightbox__caption');
    const lightboxCounter = forgeLightbox.querySelector('.forge-lightbox__counter');
    const lightboxPrev = forgeLightbox.querySelector('[data-forge-lightbox-prev]');
    const lightboxNext = forgeLightbox.querySelector('[data-forge-lightbox-next]');
    const lightboxCloseButtons = forgeLightbox.querySelectorAll('[data-forge-lightbox-close]');
    let lightboxItems = [];
    let lightboxIndex = 0;
    let lightboxLastFocus = null;
    const lightboxPreloadCache = new Set();

    function preloadLightboxSrc(url) {
      if (!url || lightboxPreloadCache.has(url)) return;
      lightboxPreloadCache.add(url);
      const img = new Image();
      img.decoding = 'async';
      img.src = url;
    }

    function preloadLightboxSlides(indices) {
      indices.forEach((slideIndex) => {
        const src = lightboxItems[slideIndex]?.src;
        if (src) preloadLightboxSrc(src);
      });
    }

    function preloadAllLightboxSlides() {
      lightboxItems.forEach((item) => preloadLightboxSrc(item.src));
    }

    function preloadAdjacentLightboxSlides(index) {
      if (lightboxItems.length <= 1) {
        preloadLightboxSrc(lightboxItems[index]?.src);
        return;
      }

      const total = lightboxItems.length;
      preloadLightboxSlides([
        index,
        (index + 1) % total,
        (index - 1 + total) % total,
      ]);
    }

    function readLightboxItems(container) {
      return Array.from(container.querySelectorAll('[data-forge-lightbox-trigger]'))
        .filter((trigger) => !trigger.hidden)
        .map((trigger) => ({
          src: trigger.dataset.forgeLightboxSrc || '',
          alt: trigger.dataset.forgeLightboxAlt || '',
          caption: trigger.dataset.forgeLightboxCaption || '',
        }))
        .filter((item) => item.src);
    }

    function renderLightboxSlide(index) {
      const item = lightboxItems[index];
      if (!item || !lightboxImage) return;

      lightboxIndex = index;
      lightboxImage.src = item.src;
      lightboxImage.alt = item.alt;

      if (lightboxCaption) {
        if (item.caption) {
          lightboxCaption.textContent = item.caption;
          lightboxCaption.hidden = false;
        } else {
          lightboxCaption.textContent = '';
          lightboxCaption.hidden = true;
        }
      }

      const hasMany = lightboxItems.length > 1;
      if (lightboxCounter) {
        lightboxCounter.textContent = hasMany ? `${index + 1} / ${lightboxItems.length}` : '';
        lightboxCounter.hidden = !hasMany;
      }
      if (lightboxPrev) lightboxPrev.hidden = !hasMany;
      if (lightboxNext) lightboxNext.hidden = !hasMany;

      preloadAdjacentLightboxSlides(index);
    }

    function openForgeLightbox(container, startIndex) {
      lightboxItems = readLightboxItems(container);
      if (!lightboxItems.length) return;

      preloadAllLightboxSlides();

      lightboxLastFocus = document.activeElement;
      renderLightboxSlide(startIndex);
      forgeLightbox.classList.add('is-open');
      forgeLightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('forge-lightbox-open');
      lightboxCloseButtons[0]?.focus();
    }

    function closeForgeLightbox() {
      forgeLightbox.classList.remove('is-open');
      forgeLightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('forge-lightbox-open');
      lightboxItems = [];
      if (lightboxImage) {
        lightboxImage.removeAttribute('src');
        lightboxImage.alt = '';
      }
      if (lightboxLastFocus instanceof HTMLElement) {
        lightboxLastFocus.focus();
      }
    }

    function stepForgeLightbox(delta) {
      if (lightboxItems.length <= 1) return;
      const nextIndex = (lightboxIndex + delta + lightboxItems.length) % lightboxItems.length;
      renderLightboxSlide(nextIndex);
    }

    document.querySelectorAll('[data-forge-lightbox]').forEach((container) => {
      container.querySelectorAll('[data-forge-lightbox-trigger]').forEach((trigger) => {
        if (trigger.dataset.forgeLightboxBound === 'true') return;
        trigger.dataset.forgeLightboxBound = 'true';

        trigger.addEventListener('click', () => {
          const items = readLightboxItems(container);
          const src = trigger.dataset.forgeLightboxSrc || '';
          const index = items.findIndex((item) => item.src === src);
          openForgeLightbox(container, index >= 0 ? index : 0);
        });
      });
    });

    lightboxCloseButtons.forEach((button) => {
      button.addEventListener('click', closeForgeLightbox);
    });

    lightboxPrev?.addEventListener('click', () => stepForgeLightbox(-1));
    lightboxNext?.addEventListener('click', () => stepForgeLightbox(1));

    document.addEventListener('keydown', (event) => {
      if (!forgeLightbox.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeForgeLightbox();
      if (event.key === 'ArrowLeft') stepForgeLightbox(-1);
      if (event.key === 'ArrowRight') stepForgeLightbox(1);
    });
  }

  /* Bannière cookies — couleurs lisibles uniquement (inline Shopify) */
  function applyCookieBannerReadableColors(scope) {
    const banner = scope instanceof Element
      ? (scope.id === 'shopify-pc__banner' ? scope : scope.querySelector('#shopify-pc__banner'))
      : document.getElementById('shopify-pc__banner');
    if (!banner) return;

    banner.querySelectorAll('h1, h2, h3, .shopify-pc__banner__heading, .shopify-pc__banner__title').forEach((el) => {
      el.style.setProperty('color', '#f5f5f5', 'important');
    });

    banner.querySelectorAll('.shopify-pc__banner__body, .shopify-pc__banner__body p, .shopify-pc__banner__dialog p').forEach((el) => {
      el.style.setProperty('color', '#e4e4ea', 'important');
    });

    banner.querySelectorAll('a').forEach((el) => {
      el.style.setProperty('color', '#ff6b00', 'important');
    });

    banner.querySelectorAll('button.shopify-pc__banner__btn-accept, button.shopify-pc__banner__btn-decline').forEach((el) => {
      el.style.setProperty('color', '#0a0a0c', 'important');
    });

    banner.querySelectorAll('button.shopify-pc__banner__btn-manage-prefs').forEach((el) => {
      el.style.setProperty('color', '#f5f5f5', 'important');
    });
  }

  applyCookieBannerReadableColors(document);

  const cookieBannerColorObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.id === 'shopify-pc__banner' || node.querySelector('#shopify-pc__banner')) {
          applyCookieBannerReadableColors(node);
        }
      });
    });
  });

  cookieBannerColorObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
